import styled from '@emotion/styled';
import Color from "color";

const AnchorButton = styled("button")`
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  line-height: 18px;
  text-decoration: underline;
  color: #3982c8;

  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
  
  &:hover {
    color: ${Color("#3982c8").darken(0.2).toString()};
  }

  &:focus {
    outline-color: #3982c8;
  }
`;

export default AnchorButton;
